import AdminOrderPromo from '../../../promo/AdminOrderPromo';
import React from 'react';
import OrderItemsList from './OrderItemsList';
import DeliveryDataCard from './DeliveryDataCard';
import AttachPaymentToOrder from '../payment/AttachPaymentToOrder';
import PromPaymentIcon from '../../../shared/PromPaymentIcon';
import PromPayByPartsIcon from '../../../shared/PromPayByPartsIcon';
import { defineOrderStatusClassName, definePaymentStatusClassName, filterPaymentTypesForOrder } from '../../../../utils/adminOrderService';
import { isScannerPickButtonAvailable } from './adminOrderScannerPickUtils';
import SelectedOrderItemsDropdown from './SelectedOrderItemsDropdown';
import OrderProfit from './OrderProfit';

const AdminOrderDesktopView = ({
  order,
  onPromoChanged,
  orderStatusesEnum,
  paymentTypesEnum,
  paymentStatusesEnum,
  getOrderInfo,
  defineOrderStatusClassName: defineOrderStatusClassNameProp,
  definePaymentStatusClassName: definePaymentStatusClassNameProp,
  handleOrderStatusChange,
  handlePaymentTypeChange,
  handlePaymentStatusChange,
  renderGenerateMessageToClipboardIcon,
  renderGeneratePreorderMessageToClipboardIcon,
  renderGeneratePreorderSoonMessageToClipboardIcon,
  renderGenerateDeliveryConfirmationMessageToClipboardIcon,
  setModalImage,
  handleEditProductOrderButtonClick,
  renderUserComment,
  renderAdminComment,
  handleEditDeliveryInfoButtonClick,
  copyToClipboard,
  detachOrderFromUser,
  disableButtons,
  onOpenCreateShipmentModal,
  onOpenDeleteShipmentModal,
  onOpenScannerPick,
  paymentRefreshKey,
  selectedOrderItemKeys,
  onToggleSelect,
  onSelectAll,
  onClearSelection,
  showSelectedDropdown,
  onToggleSelectedDropdown,
  onCloseSelectedDropdown,
  onOpenBulkDiscount,
  onOpenBulkDiscountForAll,
  onMoveSelected,
  onSplitSelected,
  onExportExcel,
  onExportInvoice,
}) => {
  const defineOrderStatus = defineOrderStatusClassNameProp || defineOrderStatusClassName;
  const definePaymentStatus = definePaymentStatusClassNameProp || definePaymentStatusClassName;
  const selectedCount = selectedOrderItemKeys?.length || 0;
  const hasOrderItems = order.orderItems?.length > 0;

  return (
    <div>
      <div className='row py-3'>
        <div className='col-12 p-0'>
          <div className='card'>
            <div className='card-header'>
              <div className='d-flex justify-content-between p-0'>
                <div className='d-flex align-items-center flex-wrap'>
                  <div className='font-weight-bold'>#{order.orderId}</div>
                  {renderGenerateMessageToClipboardIcon()}
                  {renderGeneratePreorderMessageToClipboardIcon()}
                  {renderGeneratePreorderSoonMessageToClipboardIcon()}
                  {renderGenerateDeliveryConfirmationMessageToClipboardIcon()}
                  <div className='dropdown font-size-20px ml-3'>
                    <div
                      className={defineOrderStatus(order.orderStatus)}
                      data-toggle='dropdown'
                      aria-expanded='false'
                    >
                      {order.orderStatus.adminValue}
                    </div>
                    <div className='dropdown-menu order-status'>
                      {orderStatusesEnum
                        .filter((s) => s.adminValue !== order.orderStatus.adminValue)
                        .map((status, index) => (
                          <a
                            key={index}
                            className='dropdown-item'
                            onClick={() => handleOrderStatusChange(order, status, getOrderInfo)}
                          >
                            {status.adminValue}
                          </a>
                        ))}
                    </div>
                  </div>
                  {order.promOrderId != null && (
                    <img src="/prom-logo.png" alt="Пром" className="ml-2" title="Замовлення з Пром" style={{ height: '30px', verticalAlign: 'middle' }} />
                  )}
                  {hasOrderItems && onOpenScannerPick && (
                    order.pickedWithScanner === true ? (
                      <span
                        className='ml-1 d-inline-flex align-items-center flex-shrink-0 font-weight-bold text-dark'
                        style={{ gap: '0.35rem', fontSize: '0.875rem' }}
                      >
                        <i className='bi bi-check-square-fill' style={{ fontSize: '1.08rem' }} aria-hidden='true' />
                        Зібрано зі сканером
                      </span>
                    ) : isScannerPickButtonAvailable(order) ? (
                      <button
                        type='button'
                        className='btn btn-dark btn-sm ml-1 d-inline-flex align-items-center flex-shrink-0 font-weight-bold shadow-sm border-0'
                        style={{ borderRadius: '8px', padding: '0.35rem 0.85rem' }}
                        onClick={onOpenScannerPick}
                      >
                        <i className='bi bi-upc-scan mr-1' aria-hidden='true' />
                        Зібрати сканером
                      </button>
                    ) : null
                  )}
                  {hasOrderItems && (
                    <SelectedOrderItemsDropdown
                      selectedCount={selectedCount}
                      show={showSelectedDropdown}
                      onToggleShow={onToggleSelectedDropdown}
                      onCloseDropdown={onCloseSelectedDropdown}
                      onOpenBulkDiscount={onOpenBulkDiscount}
                      onOpenBulkDiscountForAll={onOpenBulkDiscountForAll}
                      onMoveSelected={onMoveSelected}
                      onSplitSelected={onSplitSelected}
                      onExportExcel={onExportExcel}
                      onExportInvoice={onExportInvoice}
                      onClearSelection={onClearSelection}
                    />
                  )}
                </div>
                <div className='d-flex align-items-center'>
                  <div className='dropdown mr-2'>
                    <div className='dropdown-toggle' data-toggle='dropdown' aria-expanded='false'>
                      {order.paymentType.databaseValue === 'CREDIT_CARD' && <i className='bi bi-credit-card pr-1' />}
                      {order.paymentType.databaseValue === 'CASH_ON_DELIVERY' && <i className='bi bi-cash-coin pr-1' />}
                      {order.paymentType.databaseValue === 'CASH' && <i className='bi bi-cash pr-1' />}
                      {order.paymentType.databaseValue === 'PROM_PAYMENT' && <PromPaymentIcon />}
                      {order.paymentType.databaseValue === 'PROM_PAY_BY_PARTS' && <PromPayByPartsIcon />}
                      {order.paymentType.adminValue}
                    </div>
                    <div className='dropdown-menu payment-type'>
                      {filterPaymentTypesForOrder(paymentTypesEnum, order)
                        .filter((pt) => pt.adminValue !== order.paymentType.adminValue)
                        .map((paymentType, index) => (
                          <a
                            key={index}
                            className='dropdown-item'
                            onClick={() => handlePaymentTypeChange(order, paymentType, getOrderInfo)}
                          >
                            {paymentType.adminValue}
                          </a>
                        ))}
                    </div>
                  </div>
                  <div className='dropdown pb-1 mr-3'>
                    <div
                      className={definePaymentStatus(order.paymentStatus)}
                      data-toggle='dropdown'
                      aria-expanded='false'
                    >
                      {order.paymentStatus.adminValue}
                    </div>
                    <div className='dropdown-menu payment-statuses'>
                      {paymentStatusesEnum
                        .filter((ps) => ps.adminValue !== order.paymentStatus.adminValue)
                        .map((paymentStatus, index) => (
                          <a
                            key={index}
                            className='dropdown-item'
                            onClick={() => handlePaymentStatusChange(order, paymentStatus, getOrderInfo)}
                          >
                            {paymentStatus.adminValue}
                          </a>
                        ))}
                    </div>
                  </div>
                  <span className='text-muted'>{order.createTime}</span>
                </div>
              </div>
            </div>
            <div className='card-body pt-0 px-0'>
              <OrderItemsList
                order={order}
                variant='desktop'
                setModalImage={setModalImage}
                handleEditClick={handleEditProductOrderButtonClick}
                renderUserComment={renderUserComment}
                renderAdminComment={renderAdminComment}
                selectedOrderItemKeys={selectedOrderItemKeys}
                onToggleSelect={onToggleSelect}
                onSelectAll={onSelectAll}
              />
            </div>
            <div className='card-footer admin-order-totals-footer admin-order-desktop-totals-footer'>
              <OrderProfit order={order} />
              <AdminOrderPromo inputId='admin-order-promo-desktop' order={order} onChanged={onPromoChanged || getOrderInfo} />
            </div>
          </div>
        </div>
      </div>
      <div className='row pt-3'>
        <div className='col-lg-6 col-md-12 p-0 pr-lg-2'>
          <DeliveryDataCard
            order={order}
            variant='desktop'
            onEditDelivery={handleEditDeliveryInfoButtonClick}
            copyToClipboard={copyToClipboard}
            detachOrderFromUser={detachOrderFromUser}
            disableButtons={disableButtons}
            onOpenCreateShipmentModal={onOpenCreateShipmentModal}
            onOpenDeleteShipmentModal={onOpenDeleteShipmentModal}
          />
        </div>
        {order.paymentType?.databaseValue !== 'CASH_ON_DELIVERY' && (
          <div className='col-lg-6 col-md-12 p-0 pl-lg-2'>
            <AttachPaymentToOrder
              refreshKey={paymentRefreshKey}
              orderId={order.orderId}
              orderPrice={order.discountedPrice}
              orderPaymentStatus={order.paymentStatus}
              onPaymentAttached={getOrderInfo}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminOrderDesktopView;
